import axios from 'axios';
import Swal from 'sweetalert2';
import collect from 'collect.js';
import FormHelperMixin from '@SHARED/js/Vue/mixins/FormHelperMixin';
import { formatPrice } from '@SHARED/js/helpers/misc';
import template from './ShippingMethodComponent.html';
import store from '../../store/store';

// Legacy names vs new codes
const BRING_METHODS = {
  SERVICEPAKKE: '5800',
  'BPAKKE_DOR-DOR': '5000',
};

export default {
  template,

  mixins: [FormHelperMixin],

  data() {
    return {
      myBringProducts: [],
      selectedMethod: collect(BRING_METHODS).search(store.cart.preferredShippingMethod)
        ? store.cart.preferredShippingMethod
        : (store.cart.preferredShippingMethod === 'FACTORY_PICKUP' ? store.cart.preferredShippingMethod : null),
      sharedState: store, // Do not modify this directly – this is only for convenience in templates.
      isLoading: false,
    };
  },

  created() {
    if (!_.isEmpty(store.customerData.delivery_country) && !_.isEmpty(store.customerData.delivery_postal_code)) {
      this.getShippingProducts(
        store.customerData.delivery_country,
        store.customerData.delivery_postal_code,
        store.getTotalWeight(),
      );
    }
  },

  methods: {
    // Component API

    getShippingProducts(toCountry = '578', toPostalCode, weight) {
      this.isLoading = true;
      this.clearErrors();

      const data = {
        toCountry,
        toPostalCode,
        weight,
        shippingMethod: collect(BRING_METHODS).join(),
      };

      axios.post('/api/v1/mybring/shipping-cost', data)
        .then((response) => {
          this.isLoading = false;
          this.myBringProducts = response.data.products;

          if (!response.data.products) {
            this.selectedMethod = null;
          }
        })
        .catch((error) => {
          if (typeof error.response.data.errors !== 'undefined' && error.response.data.errors.length) {
            this.errors = error.response.data.errors;
          } else {
            Swal.fire(
              'Noe gikk galt',
              'Vennligst prøv igjen. Om problemet vedvarer, ring Kraftex (<a href="tel:69252530">69 25 25 30</a>).<br>' +
              'Feil utenom våre åpningstider melder du <a href="/kontakt-oss" target="_blank">her</a>, så tar vi kontakt med deg.',
              'error',
            );

            window.bugsnagClient && window.bugsnagClient.notify(error);
            throw new Error(error);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getData() {
      if (this.isLoading || !this.selectedMethod) {
        return false;
      }

      return collect(this.myBringProducts).firstWhere('id', this.selectedMethod) || { id: this.selectedMethod };
    },

    // Helpers

    formatPrice,
  },
};
